<script>
import { capitalize } from '@/helpers';

export default {
  name: 'tariffs-descriptions',
  props: {
    channel: String,
    isChannelSms: Boolean,
    isChannelViber: Boolean,
    isChannelWhatsapp: Boolean
  },
  computed: {
    tariffsDescription() {
      return this.$t('fe.tariffs.description.2', [
        `<a class="link" target="_blank" href="/mailing-settings/names/${this.channel.toLowerCase()}">${capitalize(
          this.$t('fe.mailing.settings.label')
        )}</a>`
      ]);
    },
    viberTariffDescription() {
      return this.$t('fe.tariffs.description.3', [
        `<a class="link" target="_blank" href="/feedback">${this.$t('fe.go.to.feedback')}</a>`
      ]);
    }
  }
};
</script>

<template>
  <div class="tariffs__descriptions">
    <span class="tariffs__description" v-if="isChannelSms">
      {{ $t('fe.tariffs.description.1') }}
    </span>
    <span class="tariffs__description" v-if="isChannelSms" v-html="tariffsDescription" />
    <span class="tariffs__description" v-if="isChannelWhatsapp || isChannelViber">
      {{ $t('fe.tariffs.description.4') }}
    </span>
    <span v-if="isChannelViber" v-html="viberTariffDescription" />
  </div>
</template>
